module.exports = __webpack_public_path__ + "static/stairs-34d0535c5d59ea84f788e4178274545a.jpg";